import './SplashScreen.css';
import { useEffect, useState } from 'react';

function SplashScreen({ onComplete, canExit }) {
    const [fadeOut, setFadeOut] = useState(false);
    const [minTimeElapsed, setMinTimeElapsed] = useState(false);

    useEffect(() => {
        const minTimer = setTimeout(() => {
            setMinTimeElapsed(true);
        }, 1500);

        return () => {
            clearTimeout(minTimer);
        };
    }, []);

    useEffect(() => {
        if (canExit && minTimeElapsed) {
            setFadeOut(true);

            const completeTimer = setTimeout(() => {
                if (onComplete) {
                    onComplete();
                }
            }, 1000);

            return () => {
                clearTimeout(completeTimer);
            };
        }
    }, [canExit, minTimeElapsed, onComplete]);

    return (
        <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
            <div className="splash-content">
                <img
                    src={`/cv.png`}
                    alt="Casa Viva - Mensagens para a Vida"
                    className="splash-logo"
                />
                <div className="splash-loader">
                    <div className="loader-dot"></div>
                    <div className="loader-dot"></div>
                    <div className="loader-dot"></div>
                </div>
            </div>
        </div>
    );
}

export default SplashScreen;